import { useEffect, useState } from 'react';

import { useIsMutating } from '@tanstack/react-query';

import { useGenerateEstimateQuery } from '@widgets/GenerateEstimate/lib/hooks/useGenerateEstimateQuery';
import { IFormGenerateEstimate } from '@widgets/GenerateEstimate/lib/model/types';

export const useGenerateEstimate = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const { mutateAsync, data } = useGenerateEstimateQuery();

    const onHidePopup = () => {
        setIsOpenPopup(false);
        setIsOpen(true);
    };

    const [formGenerateEstimate, setFormGenerateEstimate] = useState<IFormGenerateEstimate>({
        constructionTypeTitle: '',
        description: '',
        isUseSupplierPrices: false,
        needUseDirectories: false,
        supplierTitle: null,
        dimensions: '',
    });
    const [errorsForm, setErrorsForm] = useState({
        constructionTypeTitle: null,
        supplierTitle: null,
    });

    const isPending = useIsMutating({ mutationKey: ['generateEstimate'], exact: true }) > 0;

    const onHideModal = () => {
        setIsOpen(false);
        setFormGenerateEstimate({
            constructionTypeTitle: '',
            description: '',
            isUseSupplierPrices: false,
            needUseDirectories: false,
            supplierTitle: null,
            dimensions: '',
        });
        setErrorsForm({
            constructionTypeTitle: null,
            supplierTitle: null,
        });
    };

    const onShowModal = () => setIsOpen(true);

    const onFormGenerateEstimate = (name: string, value: string | boolean) => {
        if (name === 'constructionTypeTitle') {
            setErrorsForm({ ...errorsForm, constructionTypeTitle: null });
        }

        setFormGenerateEstimate((prevState) => {
            if (name === 'isUseSupplierPrices' && value === false) {
                return { ...prevState, [name]: value, supplierTitle: null };
            }
            return { ...prevState, [name]: value };
        });
    };

    const onSelect = (value: string) => {
        setErrorsForm({ ...errorsForm, supplierTitle: null });
        onFormGenerateEstimate('supplierTitle', value);
    };

    const onGenerateEstimate = async () => {
        if (
            !formGenerateEstimate.constructionTypeTitle ||
            (formGenerateEstimate.isUseSupplierPrices && !formGenerateEstimate.supplierTitle)
        ) {
            if (!formGenerateEstimate.constructionTypeTitle) {
                setErrorsForm({ ...errorsForm, constructionTypeTitle: 'Заполните поле' });
            }

            if (formGenerateEstimate.isUseSupplierPrices && !formGenerateEstimate.supplierTitle) {
                setErrorsForm({ ...errorsForm, supplierTitle: true });
            }
            return;
        }

        onHideModal();
        await mutateAsync(formGenerateEstimate);
    };

    useEffect(() => {
        if (data?.status === 'error') {
            const { constructionTypeTitle, description, needUseDirectories, supplierTitle } =
                data.data;

            setFormGenerateEstimate({
                constructionTypeTitle,
                description,
                needUseDirectories,
                isUseSupplierPrices: !!supplierTitle,
                supplierTitle,
                dimensions: '',
            });
            setIsOpenPopup(true);
        }
    }, [data]);

    return {
        isOpen,
        onHideModal,
        onShowModal,
        isPending,
        formGenerateEstimate,
        onFormGenerateEstimate,
        onGenerateEstimate,
        isOpenPopup,
        onHidePopup,
        data,
        onSelect,
        errorsForm,
    };
};
